/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

export const brandCdn = (process.env.REACT_APP_BRAND_CDN_URL || "https://d2008cj6nd1my7.cloudfront.net").replace(/\/$/, "");

export const navLogoUrl = `${brandCdn}/logos/SVG/Wordmark/White-Wordmark.svg`;

export const faviconUrl = `${brandCdn}/logos/SVG/Logo/faviconV2.jpg`;
